import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import {
  ContentHeader,
  FullWidthSpace,
  MainContentArea,
  ValueOrFallback,
} from "melco-ui";
import { HeaderButtonArea } from "melco-shared-logic";
import { useMachineGroup } from "../../hooks/reporting/useMachineGroup";
import { MachineGroupDetailForm } from "../../components/reporting/machineGroups/MachineGroupDetailForm";
import { MachineGroupMoreActionButton } from "../../components/reporting/machineGroups/MachineGroupMoreActionButton";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import LoadingDefaultSpinIndicator from "../../components/loading/LoadingDefaultSpinIndicator";

type MachineGroupDetailsProps = {
  machineGroupId: string;
};

export const MachineGroupDetails: React.FC<MachineGroupDetailsProps> = ({ }) => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("reporting", "reportingMachineGroups");
  const { machineGroupId } = useParams<{
    machineGroupId: string;
  }>();
  const { data: machineGroup, isLoading, refetch } = useMachineGroup(machineGroupId);
  const { name } = machineGroup || {};

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <ValueOrFallback
              value={name ?? ""}
              fallback={t("global.fallback.empty")}
            />
          }
          breadcrumb={breadcrumb}
          extra={
            <>
              <HeaderButtonArea />
              {machineGroup && (
                <MachineGroupMoreActionButton machineGroup={machineGroup} />
              )}
            </>
          }
        />
      }
      contentPadding
    >
      <FullWidthSpace direction="vertical" size="large">
        <LoadingDefaultSpinIndicator isShown={isLoading}>
          {<MachineGroupDetailForm machineGroup={machineGroup} refetch={refetch} />}
        </LoadingDefaultSpinIndicator>
      </FullWidthSpace>
    </MainContentArea>
  );
};
